import React from 'react';
import { Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

export default function PlanListItem({ plan }) {
    const timeText =
        Array.isArray(plan.time) && plan.time.length > 0
            ? plan.time.map((t) => t.text).join(', ')
            : null;

    return (
        <div className="plan-list-item">
            <Text strong className="plan-name">
                {plan.strategyName}
            </Text>
            {timeText && (
                <Text type="secondary" className="plan-time">
                    {timeText}
                </Text>
            )}
        </div>
    );
}

PlanListItem.propTypes = {
    plan: PropTypes.shape({
        _id: PropTypes.string.isRequired,
        strategyName: PropTypes.string.isRequired,
        time: PropTypes.arrayOf(
            PropTypes.shape({
                _id: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                text: PropTypes.string.isRequired,
                orderIndex: PropTypes.number.isRequired
            })
        )
    }).isRequired
};
